module.exports = __webpack_public_path__ + "img/scene-hub.d4d46a53.jpg";